import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { formatRatingValue, iconFill, parseLevels, ratingMax, ratingStep } from '@/util/ratings'

// Editable rating for one scale. Icon scales: click an icon (or its left half when the scale
// allows half steps); arrow keys step, Home clears, End sets the max. Named-level scales: a select.
// v-model: number or null (null = not rated).

const __default__ = { name: 'rating-input' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: { type: Number, default: null },
  scale: { type: Object, required: true },
  icon: { type: String, default: null },
  color: { type: String, default: null },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props





const hover = ref<number | null>(null)

const isLabels = computed(() => props.scale.display_type === 'labels')
const levels = computed(() => parseLevels(props.scale.levels))
const max = computed(() => ratingMax(props.scale as any))
const step = computed(() => ratingStep(props.scale as any))
const halfSteps = computed(() => step.value === 0.5)
const shown = computed(() => (hover.value != null ? hover.value : (props.value || 0)))
const formatted = computed(() => formatRatingValue(props.value || 0, props.scale as any))
// Each slot renders one icon of a one-icon scale, filled by the per-slot value above.
const singleIconScale = computed(() => ({ ...props.scale, display_type: 'icons', max_value: 1 }))

// The n-th slot is a one-icon scale: 1 = full, 0.5 = half, 0 = empty.
function slotValue(n: number) {
  const fill = iconFill(shown.value, n)
  return fill === 'full' ? 1 : fill === 'half' ? 0.5 : 0
}

function set(v: number | null) {
  emit('input', v)
}

function onSelect(v: number | '' | null) {
  emit('input', v === '' || v === null || v === undefined ? null : Number(v))
}

function onKeydown(e: KeyboardEvent) {
  const current = props.value || 0
  let next: number | null | undefined
  if (e.key === 'ArrowRight' || e.key === 'ArrowUp') next = Math.min(max.value, current + step.value)
  else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') next = Math.max(0, current - step.value)
  else if (e.key === 'Home') next = 0
  else if (e.key === 'End') next = max.value
  if (next === undefined) return
  e.preventDefault()
  set(next)
}

return { __sfc: true,props, emit, hover, isLabels, levels, max, step, halfSteps, shown, formatted, singleIconScale, slotValue, set, onSelect, onKeydown }
}

})